





































































import {computed, defineComponent, reactive} from "@vue/composition-api";
import {Button, InputContainer,} from "@micad/vue-components";
import Vue from "vue";
import router from "@/router";
import {QToggle,} from "quasar";
import {canIUse} from "@/modules/auth";
import WysiwygEditor from "@/components/WysiwygEditor.vue";
import {emailSend} from "@/data/repos/emailSend";
import {UserColumn} from "@/views/Users.vue";
import Loading from "@/components/Loading.vue";


export default defineComponent({
  name: "SendEmail",
  methods: {canIUse},
  props: ["users"],
  components: {
    WysiwygEditor,
    QToggle,
    InputContainer,
    Button,
    Loading,
  },
  setup(p) {
    const recipients = JSON.parse(p.users || "[]") as UserColumn[]
    const state = reactive({
      recipients: recipients,
      WysiwygEditor: "",
      subject: "",
      body: "",
      toMeOnly: false,
      showResult: false,
      numberOfUsers: computed(() => recipients.length),
      sendInProgress: false,
      submit,
      resetForm,
      goBack: () => router.back(),
    });

    async function resetForm() {
      state.subject = "";
      state.body = "";
      state.WysiwygEditor = " ";
      setTimeout(() => state.WysiwygEditor = "", 100)
    }

    resetForm().then();

    async function submit() {
      if (!state.body.length || !state.subject.length) {
        Vue.$toast.error("Both body and subject are required");
        return
      }
      state.sendInProgress = true
      try {
        const resp = await emailSend({
          subject: state.subject,
          body: state.body,
          recipients: state.recipients.map<string>(v => String(v.id))
        });
        if (resp.ok) {
          state.showResult = true;
          Vue.$toast.success("Email has been sent");
        } else {
          Vue.$toast.error("Failed to send the email");
        }
      } finally {
        state.sendInProgress = false
      }
    }

    return state;
  },
});
